import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnChanges, Output, SimpleChanges, ViewEncapsulation } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { LicenseUsersService } from '@portal-core/license-users/services/license-users.service';
import { Project } from '@portal-core/projects/models/project.model';
import { ProjectsService } from '@portal-core/projects/services/projects.service';
import { ProjectPageFilterConfig } from '@portal-core/projects/util/project-page-filter-config';
import { ListControl } from '@portal-core/ui/list/util/list-control';
import { ListBase } from '@portal-core/ui/list/util/list.base';
import { of } from 'rxjs';

@Component({
  selector: 'mc-license-user-projects-list',
  templateUrl: './license-user-projects-list.component.html',
  styleUrls: ['./license-user-projects-list.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LicenseUserProjectsListComponent extends ListBase<Project> implements OnChanges {
  @Input() licenseUserId: number;
  @Input() canEdit: boolean = false;

  @Output() saved: EventEmitter<void> = new EventEmitter<void>();

  removing: number[] = [];

  filterConfig: ProjectPageFilterConfig = new ProjectPageFilterConfig(['Name', 'Initials']);

  listControl: ListControl<Project> = new ListControl<Project>(this.projectsService, filter => {
    if (typeof this.licenseUserId === 'number') {
      return this.licenseUsersService.getProjects$(this.licenseUserId, filter);
    } else {
      return of(null);
    }
  });

  constructor(
    private licenseUsersService: LicenseUsersService,
    private projectsService: ProjectsService,
    private snackBar: MatSnackBar,
  ) {
    super(projectsService);
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.licenseUserId) {
      this.hardReload();
    }
  }

  onRemoveProject(projectId: number) {
    this.removing = [
      ...this.removing,
      projectId
    ];
    this.projectsService.deleteProjectLicenseUser$(projectId, this.licenseUserId).subscribe(() => {
      this.projectsService.removePagedDataListItems$(this.dataListId, [projectId]);
      this.removing = this.removing.filter(id => id !== projectId);
      this.saved.emit();
    }, error => {
      this.removing = this.removing.filter(id => id !== projectId);
      this.snackBar.open('Unable to remove the user from the project.', 'OK');
    });
  }
}
